(() => {
  if (window.cavelloriaStickyCart) return;
  window.cavelloriaStickyCart = true;
  let cleanup;
  function mount() {
    cleanup?.();
    const bar = document.getElementById('CavelloriaStickyCart');
    const info = document.querySelector('product-info[id^="MainProduct-"]');
    if (!bar || !info) return;
    const action = bar.querySelector('button');
    const label = action.querySelector('span');
    const price = bar.querySelector('[data-sticky-price]');
    const selection = bar.querySelector('[data-sticky-selection]');
    const spacer = document.getElementById('CavelloriaStickySpacer');
    let frame;
    const original = () => info.querySelector('product-form form[data-type="add-to-cart-form"] button[name="add"]');
    function sync() {
      frame = null;
      const button = original();
      if (!button) { bar.hidden = true; spacer.hidden = true; return; }
      const busy = button.getAttribute('aria-disabled') === 'true' || button.classList.contains('loading');
      action.disabled = button.disabled || busy;
      label.textContent = busy ? 'Adding...' : button.querySelector('span')?.textContent.trim() || 'Add to cart';
      const sourcePrice = info.querySelector('[id^="price-"] .price');
      const priceText = sourcePrice?.classList.contains('price--on-sale')
        ? sourcePrice.querySelector('.price__sale .price-item--sale')
        : sourcePrice?.querySelector('.price__regular .price-item--regular');
      price.textContent = priceText?.textContent.trim() || '';
      const options = [...info.querySelectorAll('variant-selects select')].map(el => el.selectedOptions[0]?.textContent.trim());
      if (!options.length) info.querySelectorAll('variant-selects input:checked').forEach(el => options.push(el.value));
      const quantity = info.querySelector('input[name="quantity"]')?.value || '1';
      selection.textContent = [...options.filter(Boolean), `Qty: ${quantity}`].join(' / ');
      const modalOpen = document.querySelector('dialog[open], details-modal details[open], cart-drawer.active, product-modal[open]');
      const visible = button.getBoundingClientRect().bottom < 0 && !modalOpen;
      bar.hidden = !visible;
      spacer.hidden = !visible;
      if (visible) spacer.style.height = `${bar.offsetHeight}px`;
    }
    function schedule() { if (!frame) frame = requestAnimationFrame(sync); }
    function add() {
      const button = original();
      if (!button || button.disabled || button.getAttribute('aria-disabled') === 'true') return;
      // Delegate to Refresh so variant, quantity, properties and cart behavior stay native.
      button.click();
      schedule();
    }
    const observer = new MutationObserver(schedule);
    observer.observe(info, { childList: true, subtree: true, attributes: true, characterData: true });
    const drawer = document.querySelector('cart-drawer');
    if (drawer) observer.observe(drawer, { attributes: true, attributeFilter: ['class', 'open'] });
    const errors = new MutationObserver(() => {
      const error = info.querySelector('.product-form__error-message-wrapper:not([hidden])');
      if (error && !bar.hidden) error.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });
    errors.observe(info, { subtree: true, attributes: true, attributeFilter: ['hidden'] });
    window.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', schedule);
    info.addEventListener('change', schedule);
    info.addEventListener('input', schedule);
    action.addEventListener('click', add);
    sync();
    cleanup = () => {
      observer.disconnect(); errors.disconnect(); cancelAnimationFrame(frame);
      window.removeEventListener('scroll', schedule); window.removeEventListener('resize', schedule);
      info.removeEventListener('change', schedule); info.removeEventListener('input', schedule);
      action.removeEventListener('click', add);
    };
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', mount, { once: true });
  else mount();
  document.addEventListener('shopify:section:load', mount);
})();
